export class RestoreMicrosoft365ItemsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "files",
            "baseName": "files",
            "type": "Array<FilePath>",
            "format": ""
        },
        {
            "name": "restoreMode",
            "baseName": "restoreMode",
            "type": "WorkspaceRestoreMode",
            "format": ""
        },
        {
            "name": "restoreTargetFolder",
            "baseName": "restoreTargetFolder",
            "type": "string",
            "format": ""
        },
        {
            "name": "teamsDestination",
            "baseName": "teamsDestination",
            "type": "Microsoft365TeamsRestoreDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreMicrosoft365ItemsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
